/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PaginatedDealDashboardList,
    PaginatedDealDashboardListFromJSON,
    PaginatedDealDashboardListToJSON,
    PaginatedPurposesList,
    PaginatedPurposesListFromJSON,
    PaginatedPurposesListToJSON,
} from '../models';

export interface DashboardPurposesListRequest {
    ordering?: string;
    page?: number;
    pageSize?: number;
}

export interface ListDealsDashboardRequest {
    id?: number;
    ordering?: string;
    page?: number;
    pageSize?: number;
}

export interface ListDealsDashboard2Request {
    id?: number;
    ordering?: string;
    page?: number;
    pageSize?: number;
}

/**
 * DashboardApi - interface
 * 
 * @export
 * @interface DashboardApiInterface
 */
export interface DashboardApiInterface {
    /**
     * 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    dashboardPurposesListRaw(requestParameters: DashboardPurposesListRequest): Promise<runtime.ApiResponse<PaginatedPurposesList>>;

    /**
     */
    dashboardPurposesList(requestParameters: DashboardPurposesListRequest): Promise<PaginatedPurposesList>;

    /**
     * 
     * @param {number} [id] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    listDealsDashboardRaw(requestParameters: ListDealsDashboardRequest): Promise<runtime.ApiResponse<PaginatedDealDashboardList>>;

    /**
     */
    listDealsDashboard(requestParameters: ListDealsDashboardRequest): Promise<PaginatedDealDashboardList>;

    /**
     * 
     * @param {number} [id] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    listDealsDashboard2Raw(requestParameters: ListDealsDashboard2Request): Promise<runtime.ApiResponse<PaginatedDealDashboardList>>;

    /**
     */
    listDealsDashboard2(requestParameters: ListDealsDashboard2Request): Promise<PaginatedDealDashboardList>;

}

/**
 * 
 */
export class DashboardApi extends runtime.BaseAPI implements DashboardApiInterface {

    /**
     */
    async dashboardPurposesListRaw(requestParameters: DashboardPurposesListRequest): Promise<runtime.ApiResponse<PaginatedPurposesList>> {
        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/dashboard/purposes/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPurposesListFromJSON(jsonValue));
    }

    /**
     */
    async dashboardPurposesList(requestParameters: DashboardPurposesListRequest): Promise<PaginatedPurposesList> {
        const response = await this.dashboardPurposesListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listDealsDashboardRaw(requestParameters: ListDealsDashboardRequest): Promise<runtime.ApiResponse<PaginatedDealDashboardList>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/dashboard/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDealDashboardListFromJSON(jsonValue));
    }

    /**
     */
    async listDealsDashboard(requestParameters: ListDealsDashboardRequest): Promise<PaginatedDealDashboardList> {
        const response = await this.listDealsDashboardRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listDealsDashboard2Raw(requestParameters: ListDealsDashboard2Request): Promise<runtime.ApiResponse<PaginatedDealDashboardList>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/dashboard/deals/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDealDashboardListFromJSON(jsonValue));
    }

    /**
     */
    async listDealsDashboard2(requestParameters: ListDealsDashboard2Request): Promise<PaginatedDealDashboardList> {
        const response = await this.listDealsDashboard2Raw(requestParameters);
        return await response.value();
    }

}
